import { Component, OnInit, Input, ViewChild  } from '@angular/core';
import { NavController, ModalController, NavParams ,Platform, IonSlides}  from '@ionic/angular';
import { DatabaseService }                    from '../service/database.service';
import{ Router, ActivatedRoute}    from '@angular/router';
import { ViewerModalComponent } from 'ngx-ionic-image-viewer';

@Component({
  selector: 'app-image-slider-model',
  templateUrl: './image-slider-model.page.html',
  styleUrls: ['./image-slider-model.page.scss'],
})
export class ImageSliderModelPage implements OnInit {
	
	public imagesSetDto         : any = [];
	private resetBackButton     : any;
	showImageIndex: any;

	// "value" passed in componentProps
	@Input() imageObject: any;

	constructor( 
			public navCtrl        : NavController,  
			public modalCtrl      : ModalController,
			private router        : Router, 
			private route         : ActivatedRoute ,
			public platform       : Platform,
			public navParams      : NavParams,
			public databaseService : DatabaseService) { 
		
		//Get the object from the another page
		var self = this;
		self.imageObject    = self.navParams.get('imageObject');
		self.imagesSetDto   = self.imageObject;
		setTimeout(() => {
			this.showImageIndex = this.navParams.get('imageIndex') ? this.navParams.get('imageIndex') : 0;
		}, 500);
		
	}

	ngOnInit() {
	}
	
	//for resizing
	getImageThumb(url) {
        var url1 = this.databaseService.getImageThumb(url);
        return url1;
	}
	
	//Dismiss the top modal returning some data object
	closeImageModel(){
	      this.modalCtrl.dismiss();
	}
	  
	  //computDecodeURI function for decode the imageURL to the encode format
	computDecodeURI(url) {
		return decodeURIComponent(url);
	}

	async openViewer(url) {
		const modal = await this.modalCtrl.create({
		  component: ViewerModalComponent,
		  componentProps: {
			src: url
		  },
		  cssClass: 'ion-img-viewer',
		  showBackdrop: true
		});
	
		return await modal.present();
	}
}

